<template>
  <div class="cadastrar-noticia">
    <breadcrumb :items="breadcrumbItems" />

    <h2 class="page-title">Editar Notícia:</h2>

    <div class="form-layout">
      <div class="col-left">
        <div class="field-group">
          <label class="field-label required"
            >Título
            <span
              class="help-icon"
              title="Informe o título da notícia"
              >?</span
            ></label
          >
          <input
            v-model="form.titulo"
            type="text"
            class="field-input"
          />
        </div>

        <div class="field-group">
          <label class="field-label required"
            >Fonte
            <span
              class="help-icon"
              title="Informe a fonte da notícia"
              >?</span
            ></label
          >
          <input
            v-model="form.fonte"
            type="text"
            class="field-input"
          />
        </div>

        <div class="field-group">
          <label class="field-label"
            >Imagem (Opcional)
            <span
              class="help-icon"
              title="Selecione uma imagem opcional"
              >?</span
            ></label
          >
          <div class="file-upload">
            <label
              class="btn-escolher"
              @click="triggerFileInput"
              >Escolher arquivo</label
            >
            <input
              ref="fileInput"
              type="file"
              accept="image/*"
              style="display: none"
              @change="handleFileChange"
            />
            <span class="file-name">{{
              form.imagemNome || "Nenhum arquivo escolhido"
            }}</span>
          </div>
          <div
            v-if="imagemPreview"
            class="image-preview-container"
          >
            <img
              :src="imagemPreview"
              class="image-preview"
              alt="Preview da imagem"
            />
            <button
              class="btn-remover-imagem"
              @click.prevent="removerImagem"
            >
              Remover Imagem
            </button>
          </div>
        </div>

        <div
          v-if="form.imagemNome"
          class="field-group"
        >
          <label class="field-label"
            >Descrição da Imagem
            <span
              class="help-icon"
              title="Informe uma breve descrição da imagem para acessibilidade"
              >?</span
            ></label
          >
          <input
            v-model="form.descricaoImagem"
            type="text"
            class="field-input"
            placeholder="Ex: Grupo de extensão em um evento"
          />
        </div>

        <div class="field-group">
          <label class="field-label required"
            >Palavras-chave
            <span
              class="help-icon"
              title="Adicione palavras-chave"
              >?</span
            ></label
          >
          <div class="keywords-input">
            <input
              v-model="keywordInput"
              type="text"
              class="field-input keyword-field"
              @keyup.enter="adicionarPalavra"
              placeholder=""
            />
            <button
              class="btn-adicionar"
              @click="adicionarPalavra"
            >
              Adicionar
            </button>
          </div>
          <div
            v-if="form.palavrasChave.length > 0"
            class="keywords-tags"
          >
            <span
              v-for="(palavra, index) in form.palavrasChave"
              :key="index"
              class="keyword-tag"
            >
              {{ palavra }}
              <button
                class="tag-remove"
                @click="removerPalavra(index)"
              >
                ×
              </button>
            </span>
          </div>
        </div>

        <div class="field-group">
          <label class="field-label required"
            >Abrangência
            <span
              class="help-icon"
              title="Selecione a abrangência"
              >?</span
            ></label
          >
          <div class="radio-group">
            <label
              v-for="abrangencia in abrangencias"
              :key="abrangencia.id"
              class="radio-label"
            >
              <input
                v-model="form.abrangenciaId"
                type="radio"
                :value="abrangencia.id"
              />
              <span class="radio-custom"></span>
              {{ abrangencia.abrangencia.toUpperCase() }}
            </label>
          </div>
        </div>
      </div>

      <div class="col-right">
        <div class="field-group full-height">
          <label class="field-label required"
            >Texto
            <span
              class="help-icon"
              title="Informe o texto da notícia"
              >?</span
            ></label
          >
          <div class="editor-wrapper">
            <div class="editor-toolbar">
              <button
                class="toolbar-btn"
                title="Negrito"
              >
                <strong>B</strong>
              </button>
              <button
                class="toolbar-btn italic-btn"
                title="Itálico"
              >
                <em>I</em>
              </button>
              <button
                class="toolbar-btn underline-btn"
                title="Sublinhado"
              >
                <u>U</u>
              </button>
              <button
                class="toolbar-btn"
                title="Cor do texto"
              >
                A▾
              </button>
              <div class="toolbar-divider"></div>
              <button
                class="toolbar-btn"
                title="Alinhar à esquerda"
              >
                ≡
              </button>
              <button
                class="toolbar-btn"
                title="Centralizar"
              >
                ≡
              </button>
              <button
                class="toolbar-btn"
                title="Alinhar à direita"
              >
                ≡
              </button>
              <button
                class="toolbar-btn"
                title="Justificar"
              >
                ≡
              </button>
            </div>
            <textarea
              v-model="form.texto"
              class="editor-textarea"
              placeholder=""
            ></textarea>
          </div>
        </div>

        <div class="publish-section">
          <div class="publish-row">
            <div class="field-group date-group">
              <label class="field-label"
                >Data de publicação
                <span
                  class="help-icon"
                  title="Data de publicação"
                  >?</span
                ></label
              >
              <div class="date-input-wrapper">
                <input
                  v-model="form.dataPublicacao"
                  type="date"
                  class="field-input date-input"
                  placeholder="DD/MM/AAAA"
                />
              </div>
            </div>
            <button
              class="btn-publicar"
              @click="salvar"
            >
              Salvar
            </button>
          </div>
          <span
            v-if="mostrarErro"
            class="mensagem-erro"
          >
            Dados insuficientes! Preencha os campos obrigatórios (*)
          </span>
          <span
            v-if="erroData"
            class="mensagem-erro"
          >
            {{ erroData }}
          </span>
        </div>
      </div>
    </div>

    <div
      v-if="modalConfirmacao.visivel"
      class="modal-overlay"
      @click.self="fecharModalConfirmacao"
    >
      <div class="modal-box">
        <div class="modal-header">
          <span>AVISO</span>
          <button
            class="modal-close"
            @click="fecharModalConfirmacao"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-icon">
            <svg
              viewBox="0 0 52 52"
              class="checkmark-svg"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="26"
                cy="26"
                r="25"
                fill="#5b3fa8"
              />
              <path
                d="M20 19 C 20 13, 32 13, 32 19 C 32 24, 26 25, 26 30 M26 35 L26 38"
                stroke="white"
                stroke-width="4"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p class="modal-message">Confirmar alterações?</p>
          <div class="modal-buttons">
            <button
              class="modal-cancelar"
              @click="fecharModalConfirmacao"
            >
              Voltar
            </button>
            <button
              class="modal-ok"
              @click="confirmarSalvar"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="modal.visivel"
      class="modal-overlay"
      @click.self="fecharModal"
    >
      <div class="modal-box">
        <div class="modal-header">
          <span>AVISO</span>
          <button
            class="modal-close"
            @click="fecharModal"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-icon">
            <svg
              viewBox="0 0 52 52"
              class="checkmark-svg"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="26"
                cy="26"
                r="25"
                fill="#4caf50"
              />
              <path
                d="M14 27 L22 35 L38 19"
                stroke="white"
                stroke-width="3.5"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p class="modal-message">{{ modal.mensagem }}</p>
          <button
            class="modal-ok"
            @click="fecharModal"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  onMounted,
  onBeforeUnmount,
  defineProps,
  defineEmits,
  computed,
} from "vue";
import { useRoute } from "vue-router";
import acaoService from "@/service/acaoService";
import noticiaService from "@/service/noticiaService";
import router from "@/router";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Breadcrumb from "@/components/common/Breadcrumb.vue";

dayjs.extend(utc);
dayjs.extend(timezone);

const props = defineProps({
  acaoId: {
    type: String,
    default: null,
  },
  noticiaId: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(["fechar-form-noticia", "atualizar-noticias"]);

const route = useRoute();
const fileInput = ref(null);
const keywordInput = ref("");
const dadosAcao = ref(null);
const abrangencias = ref([]);
const autor = reactive({ id: null, nome: "" });
const imagemSelecionada = ref(false);
const mostrarErro = ref(false);
const erroData = ref("");
const imagemPreview = ref("");
const currentAcaoId = ref(route.params.id || props.acaoId);

const breadcrumbItems = computed(() => {
  const acaoId = route.params.id;

  return [
    { label: "Início", to: "/" },
    { label: "Ações", to: "/suas-acoes" },
    { tipo: "acao", id: acaoId, to: `/acao/${acaoId}` },
    { label: "Notícias", to: `/acao/${acaoId}/noticias` },
    {
      label: "Editar notícia",
      to: `/acao/${acaoId}/editar-noticia/${props.noticiaId}`,
    },
  ];
});

const form = reactive({
  titulo: "",
  dataPublicacao: dayjs().format("YYYY-MM-DD"),
  texto: "",
  fonte: "",
  descricaoImagem: "",
  palavrasChave: [],
  abrangenciaId: null,
  imagemNome: "",
  imagem: {
    mimeType: "",
    base64Data: "",
  },
});

const modal = reactive({
  visivel: false,
  mensagem: "",
  tipo: "",
});

const modalConfirmacao = reactive({
  visivel: false,
});

let acaoAoFecharModal = null;

function abrirModal(mensagem) {
  modal.mensagem = mensagem;
  modal.visivel = true;
}

function fecharModal() {
  modal.visivel = false;
  if (acaoAoFecharModal) {
    acaoAoFecharModal();
    acaoAoFecharModal = null;
  }
}

function abrirModalConfirmacao() {
  modalConfirmacao.visivel = true;
}

function fecharModalConfirmacao() {
  modalConfirmacao.visivel = false;
}

function confirmarSalvar() {
  fecharModalConfirmacao();
  atualizarNoticia();
}

function triggerFileInput() {
  fileInput.value.click();
}

function handleFileChange(event) {
  const file = event.target.files[0];
  if (file) {
    form.imagemNome = file.name;
    const extensao = file.name.split(".").pop().toLowerCase();
    const extensoesPermitidas = ["png", "jpg", "jpeg"];

    if (!extensoesPermitidas.includes(extensao)) {
      alert("Arquivo não permitido. Use PNG, JPG ou JPEG.");
      return;
    }

    form.imagem.mimeType = file.type;
    const leitor = new FileReader();
    leitor.readAsDataURL(file);
    leitor.onload = () => {
      form.imagem.base64Data = leitor.result.split(",")[1];
      imagemPreview.value = leitor.result;
      imagemSelecionada.value = true;
    };
  }
}

function removerImagem() {
  form.imagemNome = "";
  form.imagem.base64Data = "";
  form.imagem.mimeType = "";
  imagemPreview.value = "";
  imagemSelecionada.value = false;
  if (fileInput.value) {
    fileInput.value.value = "";
  }
}

function adicionarPalavra() {
  const palavra = keywordInput.value.trim();
  if (palavra !== "") {
    const palavras = palavra
      .split(/[;,]+/)
      .map((p) => p.trim())
      .filter((p) => p !== "" && !form.palavrasChave.includes(p));

    if (palavras.length > 0) {
      form.palavrasChave.push(...palavras);
      keywordInput.value = "";
    } else if (form.palavrasChave.includes(palavra)) {
      alert("Não é permitido palavras repetidas");
    }
  } else {
    alert("A palavra chave não pode ser vazia");
  }
}

function removerPalavra(index) {
  form.palavrasChave.splice(index, 1);
}

function toUTC(date) {
  if (!date) return null;
  return dayjs(date)
    .tz("America/Sao_Paulo")
    .utc()
    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
}

async function carregarNoticia() {
  const noticiaId = route.params.noticiaId || props.noticiaId;
  if (!noticiaId) return;

  try {
    const response = await noticiaService.getNoticiaById(noticiaId);
    if (response) {
      const data = response;
      form.titulo = data.titulo;
      form.texto = data.texto;
      form.fonte = data.fonte;
      form.palavrasChave = data.palavrasChaves || [];

      // Corrigindo o carregamento da abrangência
      form.abrangenciaId = data.abrangencia?.id || data.abrangenciaId;

      if (!form.abrangenciaId && data.abrangenciaNome) {
        const abrangenciaMatch = abrangencias.value.find(
          (a) =>
            a.abrangencia?.toLowerCase() ===
              data.abrangenciaNome.toLowerCase() ||
            a.abrangenciaNoticia?.toLowerCase() ===
              data.abrangenciaNome.toLowerCase()
        );
        if (abrangenciaMatch) {
          form.abrangenciaId = abrangenciaMatch.id;
        }
      }

      form.dataPublicacao = dayjs(data.dataPublicacao).format("YYYY-MM-DD");
      form.descricaoImagem =
        data.descricaoImagem || data.imagem?.descricaoImagem || "";

      if (data.imagemUrl) {
        form.imagemNome = "Imagem atual";
        imagemPreview.value = data.imagemUrl;
        imagemSelecionada.value = true;

        try {
          const imgResponse = await fetch(data.imagemUrl);
          const blob = await imgResponse.blob();
          form.imagem.mimeType = blob.type;
          const reader = new FileReader();
          reader.onloadend = () => {
            if (reader.result) {
              form.imagem.base64Data = reader.result.split(",")[1];
            }
          };
          reader.readAsDataURL(blob);
        } catch (err) {
          console.error("Erro ao processar imagem atual:", err);
        }
      }

      if (!currentAcaoId.value && (data.acaoId || data.acao?.id)) {
        currentAcaoId.value = data.acaoId || data.acao?.id;
        await carregarAcao(); // Agora ele busca a ação e preenche o breadcrumb!
      }
    }
  } catch (error) {
    console.error("Erro ao carregar notícia:", error);
    alert("Erro ao carregar os dados da notícia.");
  }
}

function salvar() {
  mostrarErro.value = false;
  erroData.value = "";

  if (
    !form.titulo?.trim() ||
    !form.fonte?.trim() ||
    form.palavrasChave.length === 0 ||
    !form.abrangenciaId ||
    !form.texto?.trim() ||
    !form.dataPublicacao
  ) {
    mostrarErro.value = true;
    return;
  }

  const abrangenciaSelecionada = abrangencias.value.find(
    (a) => a.id === form.abrangenciaId
  );
  const abrangenciaNome =
    abrangenciaSelecionada?.abrangenciaNoticia?.toLowerCase() ||
    abrangenciaSelecionada?.abrangencia?.toLowerCase() ||
    "";

  if (abrangenciaNome.includes("unidade") || abrangenciaNome.includes("prex")) {
    const hoje = dayjs().startOf("day");
    const dataPub = dayjs(form.dataPublicacao).startOf("day");
    const diffDays = dataPub.diff(hoje, "day");

    if (diffDays < 7) {
      erroData.value =
        "Deve haver pelo menos um período de 7 dias em relação a criação da notícia e sua data de publicação para que o coordenador de extensão possa avaliá-la";
      return;
    }
  }

  abrirModalConfirmacao();
}

async function atualizarNoticia() {
  try {
    const noticiaId = route.params.noticiaId || props.noticiaId;
    const acaoId = currentAcaoId.value;

    if (!noticiaId) {
      return alert("Erro: ID da notícia não encontrado.");
    }

    const abrangenciaSelecionada = abrangencias.value.find(
      (a) => a.id === form.abrangenciaId
    );
    const abrangenciaNome =
      abrangenciaSelecionada?.abrangenciaNoticia?.toLowerCase() ||
      abrangenciaSelecionada?.abrangencia?.toLowerCase() ||
      "";

    const isAcao = abrangenciaNome.includes("acao");
    const mensagemSucesso = isAcao
      ? "Notícia editada com sucesso!"
      : "Sua edição foi enviada para avaliação!";

    const payloadNoticia = {
      titulo: form.titulo,
      texto: form.texto,
      fonte: form.fonte,
      descricaoImagem: form.descricaoImagem,
      palavrasChaves: [...form.palavrasChave],
      dataPublicacao: toUTC(form.dataPublicacao),
      dataAutorizacao: isAcao ? toUTC(new Date()) : null,
      abrangenciaId: form.abrangenciaId,
      autorId: autor.id,
      acaoId: acaoId,
      imagem: form.imagem.base64Data !== "" ? { ...form.imagem } : null,
    };

    await noticiaService.putNoticia(payloadNoticia, noticiaId);

    acaoAoFecharModal = () => {
      if (acaoId) {
        router.push(`/acao/${acaoId}/noticias`);
      } else {
        router.push(`/noticias`);
      }
      emit("fechar-form-noticia");
      emit("atualizar-noticias");
    };

    abrirModal(mensagemSucesso);
  } catch (error) {
    console.error("Erro ao atualizar notícia:", error);
    alert("Erro ao salvar as alterações da notícia.");
  }
}

async function carregarAcao() {
  if (currentAcaoId) {
    try {
      dadosAcao.value = await acaoService.getAcoesById(currentAcaoId.value);
    } catch (error) {
      console.error("Erro ao carregar dados da ação", error);
    }
  }
}

async function getAutor() {
  try {
    const response = await noticiaService.getAllAutorNoticia();
    if (response && response.length > 0) {
      autor.id = response[0].id;
      autor.nome = response[0].autoNoticia;
    }
  } catch (error) {
    console.error("Erro ao buscar autor:", error);
  }
}

onMounted(async () => {
  const layoutElement = document.getElementById("layout");
  if (layoutElement) layoutElement.classList.add("layout-com-cadastro");

  await carregarAcao();
  await getAutor();

  try {
    abrangencias.value = await noticiaService.getAllAbrangenciasNoticia();
  } catch (error) {
    console.error("Erro ao carregar abrangências:", error);
  }

  await carregarNoticia();
});

onBeforeUnmount(() => {
  const layoutElement = document.getElementById("layout");
  if (layoutElement) layoutElement.classList.remove("layout-com-cadastro");
});
</script>

<style scoped>
.publish-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  margin-top: auto;
}

.mensagem-erro {
  color: #e53935;
  font-size: 0.85rem;
  font-weight: 500;
}

.image-preview-container {
  margin-top: 10px;
  position: relative;
  display: inline-block;
  max-width: 100%;
}

.image-preview {
  max-width: 100%;
  max-height: 200px;
  border-radius: 4px;
  border: 1px solid #c0bcd6;
  object-fit: contain;
}

.btn-remover-imagem {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(229, 57, 53, 0.9);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-remover-imagem:hover {
  background: #d32f2f;
}

/* ── NAVBAR ── */
.header-nav {
  background: #d9d9d9;
  border-bottom: 1px solid #e0ddf0;
  margin: -24px -32px 24px -32px;
  padding: 0 48px;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  box-sizing: border-box;
}

.nav-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 14px 0;
  font-size: 0.88rem;
  font-weight: 400;
  color: #333;
  text-decoration: none;
  border-bottom: 3px solid transparent;
  transition:
    color 0.2s,
    border-color 0.2s;
  white-space: nowrap;
}

.nav-item:hover {
  color: #4a3090;
  border-bottom-color: #c0b4e8;
}

.nav-item--active {
  color: #4a3090;
  border-bottom-color: #4a3090;
  font-weight: 600;
}

.cadastrar-noticia {
  font-family: var(--font-base);
  color: var(--preto);
}

.page-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--preto);
  margin-bottom: 24px;
}

.form-layout {
  display: flex;
  gap: 32px;
  align-items: flex-start;
}

.col-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.col-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Field groups */
.field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-group.full-height {
  flex: 1;
}

.field-label {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--preto);
  display: flex;
  align-items: center;
  gap: 6px;
}

.field-label.required::before {
  content: "*";
  color: #5b3fa8;
}

.help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #9e9e9e;
  color: var(--branco);
  font-size: 0.65rem;
  font-weight: bold;
  cursor: pointer;
}

.field-input {
  border: 1px solid #c0bcd6;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: 0.9rem;
  color: var(--preto);
  outline: none;
  transition: border-color 0.2s;
  width: 100%;
  box-sizing: border-box;
}

.field-input:focus {
  border-color: #5b3fa8;
  box-shadow: 0 0 0 2px rgba(91, 63, 168, 0.12);
}

/* File upload */
.file-upload {
  display: flex;
  align-items: center;
  border: 1px solid #c0bcd6;
  border-radius: 4px;
  overflow: hidden;
}

.btn-escolher {
  background: #5b3fa8;
  color: var(--branco);
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.2s;
}

.btn-escolher:hover {
  background: #4a3090;
}

.file-name {
  padding: 8px 12px;
  font-size: 0.85rem;
  color: #666;
  flex: 1;
  background: var(--branco);
}

/* Keywords */
.keywords-input {
  display: flex;
  gap: 8px;
}

.keyword-field {
  flex: 1;
}

.btn-adicionar {
  background: #5b3fa8;
  color: var(--branco);
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}

.btn-adicionar:hover {
  background: #4a3090;
}

.keywords-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.keyword-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #ede9f8;
  color: #5b3fa8;
  border-radius: 12px;
  padding: 3px 10px;
  font-size: 0.8rem;
  font-weight: 500;
}

.tag-remove {
  background: none;
  border: none;
  color: #5b3fa8;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  padding: 0;
}

/* Radio */
.radio-group {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  border: 1px solid #c0bcd6;
  border-radius: 4px;
  padding: 10px 14px;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--preto);
  cursor: pointer;
  position: relative;
}

.radio-label input[type="radio"] {
  accent-color: #5b3fa8;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.radio-custom {
  display: none;
}

/* Editor */
.editor-wrapper {
  border: 1px solid #c0bcd6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 280px;
}

.editor-toolbar {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 6px 10px;
  background: #f9f8fd;
  border-bottom: 1px solid #ddd;
}

.toolbar-btn {
  background: none;
  border: none;
  padding: 4px 7px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--preto);
  transition: background 0.15s;
}

.toolbar-btn:hover {
  background: #ede9f8;
  color: #5b3fa8;
}

.toolbar-divider {
  width: 1px;
  height: 18px;
  background: #ddd;
  margin: 0 4px;
}

.editor-textarea {
  flex: 1;
  border: none;
  outline: none;
  padding: 12px;
  font-size: 0.9rem;
  font-family: inherit;
  resize: none;
  color: var(--preto);
  min-height: 230px;
  box-sizing: border-box;
}

/* Publish row */
.publish-row {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 16px;
}

.date-group {
  flex-direction: column;
  gap: 4px;
}

.date-input-wrapper {
  position: relative;
}

.date-input {
  padding-right: 36px;
  min-width: 160px;
}

.btn-publicar {
  background: #5b3fa8;
  color: var(--branco);
  border: none;
  border-radius: 4px;
  padding: 10px 28px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}

.btn-publicar:hover {
  background: #4a3090;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  background: var(--branco);
  border-radius: 6px;
  min-width: 300px;
  max-width: 380px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.modal-header {
  background: #4a3090;
  color: var(--branco);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.04em;
}

.modal-close {
  background: #6d4fc4;
  border: none;
  color: var(--branco);
  font-size: 1.1rem;
  cursor: pointer;
  border-radius: 3px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.modal-close:hover {
  background: #3a2070;
}

.modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px 24px;
  gap: 16px;
}

.modal-icon {
  width: 56px;
  height: 56px;
}

.checkmark-svg {
  width: 100%;
  height: 100%;
}

.modal-message {
  font-size: 1rem;
  font-weight: 600;
  color: var(--preto);
  text-align: center;
  margin: 0;
}

.modal-ok {
  background: #5b3fa8;
  color: var(--branco);
  border: none;
  border-radius: 6px;
  padding: 8px 36px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 4px;
}

.modal-ok:hover {
  background: #4a3090;
}

.modal-buttons {
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: center;
  margin-top: 8px;
}

.modal-cancelar {
  background: transparent; /* Fundo transparente */
  color: #1a1a24; /* Cor do texto escura */
  border: 1px solid #1a1a24; /* Borda escura */
  border-radius: 6px; /* Alterado de 20px para 6px */
  padding: 8px 36px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s,
    color 0.2s;
  margin-top: 4px;
}

.modal-cancelar:hover {
  background: #f0f0f0;
}

/* Responsive */
@media (max-width: 768px) {
  .form-layout {
    flex-direction: column;
  }

  .col-left {
    flex: unset;
    width: 100%;
  }

  .publish-row {
    flex-direction: column;
    align-items: flex-end;
  }
}
</style>
